var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"600","content-class":"simpleDialog"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"pa-10",on:{"click":function($event){_vm.dialog = false}}},_vm._l((_vm.contents),function(content){return _c('div',[_vm._v(_vm._s(content))])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }